import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { ColDef } from "ag-grid-community";
import { Button } from "@material-tailwind/react";

interface Props {
    participantsData: ParticipantsType[];
}
export type ParticipantsType = {
    participant_name: string;
    participant_email: string;
    provider: string;
    created_at: string;
    logged_time: string;
};

function userTables({ participantsData }: Props) {
    const [rowData, setRowData] = useState<any[]>([]);

    useEffect(() => {
        const formattedData = participantsData.map((item, index) => {
            if (Array.isArray(item)) {
                return {
                    SNo: index + 1,
                    participant_name: item[2],
                    participant_email: item[1],
                    provider: item[3] == null ? "custom" : item[3],
                    created_at: item[4],
                    logged_time: item[5]
                };
            }
            return { SNo: "", Name: "", Email: "", Provider: "", "Created At":"", "Last Login":""  };
        });

        setRowData(formattedData);
    }, [participantsData]);
    const colDefs: ColDef<ParticipantsType>[] = [
        { field: "participant_name", headerName: "Name", width: 300 },
        { field: "participant_email", headerName: "Email", width: 350 },
        { field: "provider", headerName: "Provider", width: 150 },
        { field: "created_at", headerName: "Created At", width: 200 },
        { field: "logged_time", headerName: "Last Login", width: 200 }
    ];

    const defaultColDef: ColDef = {
        flex: 0,
        filter: true,
        editable: false,
        resizable: true
    };
    // ✅ CSV Export Function (Frontend-based)
    const handleExportCSV = () => {
        if (!rowData || rowData.length === 0) {
            alert("No data to export");
            return;
        }

        // Define headers
        const headers = ["Name", "Email", "Provider", "Created At", "Last Login"];

        // Map data
        const rows = rowData.map(item => [item.participant_name, item.participant_email, item.provider, item.created_at, item.logged_time]);

        // Convert to CSV format
        const csvContent = [headers, ...rows].map(row => row.map(val => `"${val ?? ""}"`).join(",")).join("\n");

        // Create blob
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = `participants-${new Date().toISOString().split("T")[0]}.csv`;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    return (
        <div style={{ width: "100%", height: "100%" }}>
            <div className="ag-theme-quartz " style={{ marginTop: "20px", width: "100%", height: "90%" }}>
                <AgGridReact rowData={rowData} columnDefs={colDefs} defaultColDef={defaultColDef} cellSelection={true} enableCellTextSelection={true} />
            </div>
            {/* ✅ Export Button */}
            <div className="w-full text-center">
                <Button
                    onClick={handleExportCSV}
                    className="min-w-36 h-10 font-medium bg-blue-400 text-white px-2 m-3"
                    style={{
                        marginBottom: "10px",
                        padding: "8px 16px",
                        cursor: "pointer"
                    }}
                >
                    Export list
                </Button>
            </div>
        </div>
    );
}

export default userTables;
